/**
 * @Date：2018年12月12日 15:02
 * @Desc：参数码表
 */
let params = {
    // XXXX
    XXXX_COD: [
        {
            value: '0',
            text: '年'
        },
        {
            value: '1',
            text: '月'
        },
        {
            value: '2',
            text: '天'
        }
    ],
    // 性别
    GENDER_COD: [
        {
            value: 0,
            text: '女'
        },
        {
            value: 1,
            text: '男'
        },
        {
            value: 2,
            text: '保密'
        }
    ]
}

export default params



// WEBPACK FOOTER //
// ./src/common/params.js